import { z } from 'zod'

export const SupportRequestCounterZod = z.object({
  next: z.number().int(),
})
